import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { FormBuilder, Validators,  AbstractControl, ValidationErrors } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatStep, StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentService } from 'src/app/services/payment.service';
import { StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SlotSelectionComponent } from 'src/app/components/slot-selection/slot-selection.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from "@angular/router";

import {ErrorStateMatcher} from '@angular/material/core';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss']
})
export class BookingComponent implements OnInit {
  @ViewChild('stepper') myStepper: any;
  @ViewChild('stepOne') infoStep!: MatStep;
  @ViewChild('stepTwo') slotStep!: MatStep;
  @ViewChild('stepThree') summaryStep!: MatStep;
  @ViewChild('slotSelector', { static: false }) slotSelector!: SlotSelectionComponent;
  doctors: any;

  count = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  secondCount = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  countForm = this.fb.group({
    // country: ['', [Validators.required]],
    // adult: [1, []],
    // child: [0, []],
    name: ['', [Validators.required, Validators.pattern("^[a-zA-Z ]{3,150}$")]],
    patient: [''],
    gender: ['', Validators.required],
    mrNumber: [''],
    dob: ['', [Validators.required, this.dateOfBirthValidator]],

    isRevisit: [false]
    // email: ['', [Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/), Validators.required]],
    // phone: ['', [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.required]]
  });
  firstFormGroup = this.fb.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this.fb.group({
    secondCtrl: ['', Validators.required],
  });
  isCompleted = false;
  isLoading = false;
  isChild = false;
  stepperOrientation: Observable<StepperOrientation>;
  modalReady = false;
  datesToHighlight: any;
  slots: any;
  bookingData: any;
  selectedSlot: any;
  bookingDetails: any;
  countryId: any;
  childTotal: any;
  adultTotal: any;
  total: any;
  totalCount: any;
  userEmail = '';
  isVerified = false;
  emailError = '';
  slotCheckCount = 1;
  doctor :any;
  userDetails: any;
  userId: any;
  allPatients: any[] = [];
  isChecked: boolean = true;
  isRevisit: any = 0; 
  whatsapp_notification: any;
  revisit: any = "false";
  doctorId: any;
  doctorBranchId: any;
  userData: any;
  form_data: any;
  no_of_adult: number = 1;
  no_of_child: number = 0;
  slotBookingData: any;
  slotExistingPatientData: any;
  getSelectedDoctorsList: any;
  patientData: any;
  patientId: any = null;
  accessToken: any;

  @ViewChild('emailConfirmation') emailConfirmation!: TemplateRef<any>;
  paymentBookingDetails: any;
  slotPriceDetails: any;
  

  constructor(private fb: FormBuilder, private apiService: ApiService, 
    breakpointObserver: BreakpointObserver, private paymentService: PaymentService, 
    private storage: StorageService, private authService: AuthService, 
    private router: Router, private route: ActivatedRoute, 
    public dialog: MatDialog, 
    private snackBar: MatSnackBar, private spinner: NgxSpinnerService,
    private changeDetectorRef: ChangeDetectorRef) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }
  get f() { return this.countForm.controls; }

  onStepChange(index: any) {
    if(index == 0){
      this.isCompleted = false;
      this.myStepper.reset();
    }
  }

  filterCount(e: any) {
    if (e.value !== '') {
      this.count = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      this.secondCount = this.count.filter((value) => { return value <= (10 - e.value); });
      this.isCompleted = false;
      if (this.slotStep && this.summaryStep !== undefined) {
        this.slotStep.reset();
        this.summaryStep.reset();
      }

    }
  }

  secondFilterCount(e: any) {
    if (e.value !== '') {
      this.secondCount = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      this.count = this.secondCount.filter((value) => { return value <= (10 - e.value); });
      this.isCompleted = false;
      if (this.slotStep && this.summaryStep !== undefined) {
        this.slotStep.reset();
        this.summaryStep.reset();
      }
    }

  }


  dateOfBirthValidator(control: AbstractControl): ValidationErrors | null {
    const today = new Date();
    const dob = new Date(control.value);
    return dob < today ? null : { invalidDateOfBirth: true };
  }
  

  async goToSlot() {

    
    //Getting Whatsapp check box value
    // this.revisit = this.isRevisit ? 1 : 0;


    //Getting Whatsapp check box value
    this.whatsapp_notification = this.isChecked ? 1 : 0;

    this.datesToHighlight = [];
    this.isLoading = true;
    this.bookingData = {
      "name": this.f.name.value,
      "gender": this.f.gender.value,
      "dob": this.f.dob.value,
      "mrNumber": this.f.mrNumber.value,
      "whatsapp_notification": this.whatsapp_notification,
      "isRevisit": this.isRevisit
    };
    this.bookingDetails = {
      "name": this.f.name.value,
      "gender": this.f.gender.value,
      "dob": this.f.dob.value,
      "mrNumber": this.f.mrNumber.value,
      "whatsapp_notification": this.whatsapp_notification,
    };

    this.paymentBookingDetails = {
      "name": this.f.name.value,
      "gender": this.f.gender.value,
      "dob": this.f.dob.value,
      "mrNumber": this.f.mrNumber.value,
      "whatsapp_notification": this.whatsapp_notification,
      'phone': this.userData.data.phone,
      'email': this.userData.data.email,
      'revisit': this.revisit,

    };

    // this.storage.set('booking_form_data', JSON.stringify(this.bookingData));

    if (this.countForm.valid) {
      this.bookingDetails = this.countForm.value;
      // this.myStepper.next();
    }
    // Checking whether patientId is available or not
    if(this.isRevisit === true) {
      if(this.patientId != null) {
        await this.getMonthSlots(null);
      }else {
        this.snackBar.open('Please select a patient from the dropdown above to continue with an existing booking.', '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'center'
        });
        this.isLoading = false;
      }
    }else {
      await this.getMonthSlots(null);
    }
    

  }

  async getMonthSlots(month: number | null) {
    
    const details = {
      'name': this.bookingData.name,
    };
    if(this.accessToken) {
      await this.apiService.getMonthSlots(month, this.isChild, this.doctorId, this.doctorBranchId).then((data: any) => {
        if (data.success === true && Object.keys(data['data']).length > 0) {
          this.apiService.monthSlots.next(data["data"].date);
          this.apiService.monthSlots.subscribe((data: any) => {
            this.datesToHighlight = data;
            
          });
          this.getSlots();
        } else if (data["true"] && Object.keys(data['data']).length == 0) {
          this.snackBar.open('No slots available', '', {
            duration: 2000,
            horizontalPosition: 'center',
            panelClass: 'text-center'
          });
          this.isLoading = false;
        } else {
          this.snackBar.open('Sorry! No slots available or Unable to fetch slots this time. Please try again later', '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'center'
          });
          this.isLoading = false;
        }
      });
    }else {
      this.snackBar.open('Please log in to book a slot', '', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'center'
      });
      this.isLoading = false;
    }
  }

  getSlots() {
    this.isCompleted = true;
    if(this.isRevisit === true) {
      this.patientId = this.patientId;
      this.revisit = this.isRevisit;
      
    }else {
      this.patientId = null;
    }
    this.apiService.getSlotsByDate(this.datesToHighlight[0],  this.isChild, this.doctorId, this.doctorBranchId, this.patientId, this.isRevisit).subscribe({
      next: (data: any) => {
        if (data.success === true) {
          
          //sorting by date and filtering by booking start and booking end date
          let currentDate = new Date();
          this.slotPriceDetails = data.booking_charge;
          let slotData = data["data"].sort((firstEl: any, secondEl: any) => Date.parse(firstEl.start_time) - Date.parse(secondEl.start_time)).filter(
            (element: any) => currentDate >= new Date(element.time_limits.booking_start_time) && currentDate <= new Date(element.time_limits.booking_end_time)
          );
          slotData.forEach((element: any, index: number) => {
            if (this.slotCheckCount <= +element.available_slot_count) {
              slotData[index].slotsLimited = false;
            } else {
              slotData[index].slotsLimited = true;
            }
          });
          this.apiService.slots.next(slotData);
          this.apiService.slots.subscribe((data: any) => {
            this.slots = data;
          });
          this.apiService.isSlotsLoaded.next(true);
        } else {
          this.isLoading = false;
          this.apiService.isSlotsLoaded.next(false);
        }
      },

      error: (err: any) => {
        this.apiService.slots.next([]);
        this.apiService.isSlotsLoaded.next(false);
        this.isLoading = false;
      },
      complete: () => {
        this.myStepper.next();
        this.isCompleted = false;
        this.isLoading = false;
      }
    });

  }

  async summary(data: { slot: any, slotPriceDetails: any }) {
    // this.form_data = JSON.parse(this.storage.get('booking_form_data') || '[]');
    this.isLoading = true;
    let price = this.storage.get('country_price') || 0;
    this.total = this.adultTotal + this.childTotal;
    this.selectedSlot = data.slot;
    this.bookingDetails.slot_id = data.slot.id;
    this.bookingData = {
      ...this.bookingData,
      'slot_id': data.slot.id,
      'booking_date': new Date,
      'slot_start': this.selectedSlot.start_time,
      'slot_end': this.selectedSlot.end_time,
      'total': 35,
      'phone': this.userData.data.phone,
      'email': this.userData.data.email,
      'revisit': this.revisit,
      'isRevisit': this.isRevisit,
      'mrnumber': this.f.mrNumber.value,
      // 'name': this.form_data.name,
      'name': this.f.name.value,
      'gender': this.f.gender.value,
      'no_of_adults': this.no_of_adult,
      'no_of_childs': this.no_of_child,
      'booking_charge': this.slotPriceDetails,
      // 'revisit_charge': this.slotPriceDetails.revisit_charge,
    };
    
    this.isCompleted = true;
    setTimeout(() => {
      this.myStepper.next();
    }, 100);
    this.isLoading = false;
  }

  async slotRegistration() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    await this.bookSlot();

  }

  async bookSlot() {
    this.bookingDetails = this.countForm.value;
    this.slotBookingData = {
      'slot_id': this.selectedSlot.id,
      'no_of_adults': this.no_of_adult,
      'no_of_childs': this.no_of_child,
      'mrnumber': this.f.mrNumber.value,
      'name': this.f.name.value,
      "dob": "2002-02-13",
      'gender': this.f.gender.value,
      'phone': this.userData.data.phone,
      'email': this.userData.data.email,
      'revisit': this.isRevisit,
      "whatsapp_notification": this.whatsapp_notification,
    }
    this.slotExistingPatientData = {
      'slot_id': this.selectedSlot.id,
      'revisit': this.isRevisit,
      'patientID': this.patientId,
      "whatsapp_notification": this.whatsapp_notification,
      'phone': this.userData.data.phone,
      'email': this.userData.data.email,
    }
    
    

    if(this.isRevisit === true) {
      await this.apiService.existingPatientBooking(this.slotExistingPatientData).then(
        (data: any) => {
          if (data.success == true) {
            this.bookingDetails.order_id = data['data'].order_id;
            this.bookingDetails.amount = data['data'].amount;
            this.bookingDetails.booking_id = data['data'].booking_id;
            this.bookingDetails.payment_method = "1";
            this.bookingDetails.email = this.userData.data.email;
            this.bookingDetails.phone = this.userData.data.phone;
            this.bookingDetails.doctor = data['data'].doctor;
            this.bookingDetails.hospital = data['data'].hospital;
            this.bookingDetails.booking_date = data['data'].booking_date;
            this.bookingDetails.slot_time = data['data'].slot_time;
            
            this.goToPayment();
            this.isLoading = false;
          } else {
            this.snackBar.open(data.message, '', {
              duration: 2000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'center'
            });
          }
        },
        (error) => {
          this.isLoading = false;
          this.snackBar.open(error.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'center'
          });
        });
    }else {
      await this.apiService.booking(this.slotBookingData).then(
        (data: any) => {
          if (data.success === true) {
            this.bookingDetails.order_id = data['data'].order_id;
            this.bookingDetails.amount = data['data'].amount;
            this.bookingDetails.booking_id = data['data'].booking_id;
            this.bookingDetails.payment_method = "1";
            this.bookingDetails.appointmentToken = data['data'].appointmentToken;
            this.bookingDetails.email = this.userData.data.email;
            this.bookingDetails.phone = this.userData.data.phone;
            this.bookingDetails.doctor = data['data'].doctor;
            this.bookingDetails.hospital = data['data'].hospital;
            this.bookingDetails.booking_date = data['data'].booking_date;
            this.bookingDetails.slot_time = data['data'].slot_time;
            
            this.goToPayment();
            this.isLoading = false;
            
          } else {
            this.snackBar.open(data.error.message, '', {
              duration: 2000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'center'
            });
          }
        },
        (error) => {
          this.isLoading = false;
          this.snackBar.open(error.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'center'
          });
        });
    }

    
  }

  async goToPayment() {
    // this.bookingDetails = this.countForm.value;
    this.paymentService.pay(this.bookingDetails);
  }

  selectCountry() {
    if (this.countryId) {
      let selectedCountry = this.doctors.filter((x: any) => x.id == this.countryId);
      if (selectedCountry && selectedCountry.length > 0) {
        this.storage.set('form_id', selectedCountry[0].related_forms[0].id);
        this.storage.set('country_price', selectedCountry[0].price);
      }
    }
    this.isCompleted = false;
    this.isLoading = false;
  }

  async calendarBack() {
    // this.datesToHighlight = [];
    await this.myStepper.previous();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  // Api call for getting all patients according to token
  getAllPatientsList() {
    this.apiService.getAllPatientDetails().subscribe((response: any) => {
      try {
        if (response.success === true) {
          this.allPatients = response.data;
        } 
      }catch(err) {
      }
    });
  }

  // Api call for getting selected patient details
  getPatientData(patientId: any) {
    this.apiService.getPatientDetails(patientId).subscribe((response: any) => {
      try {
        if (response.success === true) {
          this.patientData = response.data;
          this.patientId = response.data.id;
        // Convert the dob string to a Date object
        const dobString: any = this.patientData.dob;
        const dob:any = this.parseDateString(dobString);

        // Map gender string to the corresponding value
        const genderMap: any = {
          'Male': '1',
          'Female': '0'
        };
        const genderValue = genderMap[this.patientData.gender];

        this.isRevisit = true;

         //Getting Whatsapp check box value
          this.revisit = this.isRevisit ? 1 : 0;

          // Updating value to the respective mat form fields
          this.countForm.patchValue({
            name: this.patientData.name,
            gender: genderValue,
            dob: dob,
            mrNumber: this.patientData.mrnumber,
          });
        } 
      }catch(err) {
      }
    });
  }

  // Parsing date from the api
  parseDateString(dateString: string): Date | null {
    const [day, month, year] = dateString.split('-');
    if (year && month && day) {
      return new Date(+year, +month - 1, +day);
    }
    return null;
  }

  goToLogin() {
    // this.router.navigate(['/login']);

  const currentUrl = this.router.url;
  this.router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
  }


  ngOnInit(): void { 
    
    this.accessToken = this.storage.get('token');
    this.spinner.show();

    this.userData = this.storage.get('user_data')? JSON.parse(this.storage.get('user_data')||'{}'):null;

    this.route.paramMap.subscribe(params => {
      this.doctorId = params.get('id') || '';
    });

    if(this.doctorId) {
      this.apiService.getDoctorDetails(this.doctorId).subscribe({
        next: (data: any) => {
          if (data.success == true) {
            //sorting by date and filtering by booking start and booking end date
            this.doctor = data.data;
            this.doctorId = this.doctor.id;
            this.doctorBranchId = this.doctor.branches[0].branch.id;
          } else {
            this.spinner.show();
            this.isLoading = false;
          }
        },
  
        error: (err: any) => {
          this.spinner.hide();
          this.isLoading = false;
        },
        complete: () => {
          this.spinner.hide();
          this.isLoading = false;
        }
      });
    }else {
      this.router.navigate(['/dashboard']);
    }

    this.userDetails =  JSON.parse(this.storage.get('user_data') || '[]');

    this.userId = this.userDetails.data.id;
    
    this.getAllPatientsList();

    setTimeout(() => {
      this.modalReady = true;
    }, 0);

  }

  ngOnChanges(){

  }

  


}

